//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Features.js";
import "../no/TemplateTestManager.js";
let d=[[],[[["testName","version","errorCodes","features"],"TouchUpdateTemplateTest",{},4,0],[["testName","version","errorCodes","features"],"DeleteTemplateTest",{},4,0],[["testName","version","errorCodes","features"],"RenewTemplateTest",{},4,0],[["testName","version","errorCodes","features"],"SuppressTemplateTest",{},4,0],[["testName","version","errorCodes","features"],"CopyPasteTemplateTest",{},4,0],[["testName","version","errorCodes","patternfeature0","axis","point"],"RunPatternTemplateTest",{},6,0],[["testName","version","errorCodes","mirrorfeature0","plane"],"RunMirrorTemplateTest",{},5,0],[["testName","version","errorCodes","part"],"RunChecksumTemplateTest",{},4,0],[["testName","version","errorCodes","sketchcurves1"],"RunSketchPreviewDimensionTest",{},4,0],[["testName","version","errorCodes"],"RunTopOptROVETemplateTest",{},3,0],[["testName","version","actionName","selectedObjectsInDiagram","selectedObjectsInDetails","enabledFilters","enabledPreferences","printXMLData"],"RunInterpartNavigatorAction",{},8,0]],[]];
SPLM.ModlTemplateTestManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ModlTemplateTestManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;